module.exports = __webpack_public_path__ + "static/media/SerotrackerLogo.157d7250.svg";